'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.integrations = exports.versionNumber = exports.TwoFactor = exports.Register = exports.Login = exports.ForgotPassword = exports.Feed = exports.Canvas = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _integrations = require('./integrations');

Object.defineProperty(exports, 'integrations', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_integrations).default;
  }
});
exports.fromTag = fromTag;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _store = require('./store');

var _actions = require('./actions');

var _css = require('./utils/css');

var _mason = require('./utils/mason');

var _mason2 = _interopRequireDefault(_mason);

var _masonCanvas = require('./components/mason-canvas');

var _masonCanvas2 = _interopRequireDefault(_masonCanvas);

var _masonFeed = require('./components/mason-feed');

var _masonFeed2 = _interopRequireDefault(_masonFeed);

var _masonForgotPassword = require('./components/mason-forgot-password');

var _masonForgotPassword2 = _interopRequireDefault(_masonForgotPassword);

var _masonLogin = require('./components/mason-login');

var _masonLogin2 = _interopRequireDefault(_masonLogin);

var _masonRegister = require('./components/mason-register');

var _masonRegister2 = _interopRequireDefault(_masonRegister);

var _masonTwoFactor = require('./components/mason-two-factor');

var _masonTwoFactor2 = _interopRequireDefault(_masonTwoFactor);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // components


exports.Canvas = _masonCanvas2.default;
exports.Feed = _masonFeed2.default;
exports.ForgotPassword = _masonForgotPassword2.default;
exports.Login = _masonLogin2.default;
exports.Register = _masonRegister2.default;
exports.TwoFactor = _masonTwoFactor2.default;
var versionNumber = exports.versionNumber = '3.2.10'; // integrations

function Mason() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var store = (0, _store.getStore)();

  if (!store) {
    return;
  }

  store.dispatch((0, _actions.setOptions)(_extends({}, options, {
    versionNumber: versionNumber
  })));

  if (!options.apiKey) {
    console.error('Mason requires `apiKey` option to be provided');
    return;
  }

  var componentIds = options.componentIds,
      projectId = options.projectId;
  var pIds = _lodash2.default.isArray(projectId) ? projectId : [projectId];
  var masonUtils = (0, _mason2.default)(store.getState().mason);
  (0, _css.prependBoilerplateStylesheet)();

  if (projectId && pIds.length) {
    store.dispatch((0, _actions.fetchProjects)(pIds, function (components, projects) {
      (0, _actions.fetchStylesheets)(pIds, components, projects, masonUtils.urls.stylesheet, options.didFetchStylesheets, options.draft)(store.dispatch, store.getState);

      if (options.didFetchComponents) {
        return options.didFetchComponents(components);
      }

      return components;
    }));
    (0, _css.insertProjectStylesheet)(pIds, masonUtils.urls.stylesheet);
  }

  if (_lodash2.default.isArray(componentIds) && componentIds.length > 0) {
    store.dispatch((0, _actions.fetchComponents)(componentIds, options.didFetchComponents));
    (0, _css.insertComponentStylesheet)(componentIds, masonUtils.urls.components);
  }
}

Mason.callback = function (name, f, componentId) {
  if (_lodash2.default.isFunction(f) && _lodash2.default.includes(['didFetchData', 'didReceiveData', 'willFetchData', 'willSendData'], name)) {
    var store = (0, _store.getStore)();

    if (!store) {
      return false;
    }

    store.dispatch((0, _actions.addCallback)({
      name: name,
      f: f,
      componentId: componentId
    }));
    return true;
  }

  return false;
}; // used externally, do not delete


function fromTag(tag) {
  var componentsByTag = {
    'mason-canvas': _masonCanvas2.default,
    'mason-feed': _masonFeed2.default,
    'mason-forgot-password': _masonForgotPassword2.default,
    'mason-login': _masonLogin2.default,
    'mason-register': _masonRegister2.default,
    'mason-two-factor': _masonTwoFactor2.default
  };
  return _lodash2.default.get(componentsByTag, tag, _masonCanvas2.default);
}

exports.default = Mason;